(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pz-product"] && !Shopify.designMode) return;
  try {
    
function initPipzooProduct(root) {
  root.querySelectorAll('[data-pz-product]').forEach(section => {
    if (section.dataset.productReady) return;
    section.dataset.productReady = 'true';
    section.querySelector('[data-pz-variant]')?.addEventListener('change', event => {
      const option = event.target.selectedOptions[0];
      const input = section.querySelector('[data-pz-variant-input]');
      if (input) { input.value = option.value; input.dispatchEvent(new Event('change', { bubbles: true })); }
      const price = section.querySelector('[data-pz-price]');
      if (price) price.innerHTML = option.dataset.price;
      const button = section.querySelector('[data-pz-buy]');
      if (button) { button.disabled = option.dataset.available !== 'true'; button.textContent = button.disabled ? 'Sold out' : button.dataset.label; }
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initPipzooProduct(document));
else initPipzooProduct(document);
document.addEventListener('shopify:section:load', event => initPipzooProduct(event.target));

  } catch(e) { console.error(e); }
})();
})();
